import React from 'react'
import {
  Layout,
  Header,
  Showcase,
  SectionTitle,
  Intro,
} from '../../../../components'

import data from './data.json'

export default () => {
  const showTab = (event, content) => {
    let tabContent = [...document.getElementsByClassName('c-tabs__content')]
    tabContent.forEach(content => {
      content.style.display = 'none'
    })

    let tabLinks = [...document.getElementsByClassName('c-tabs__tab')]
    tabLinks.forEach(tab => {
      tab.className = tab.className.replace(' c-tabs__tab--active', '')
    })

    document.getElementById(content).style.display = 'block'
    event.currentTarget.className += ' c-tabs__tab--active'
  }
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            Tabs allow the user to quickly navigate between 2 to 4 views on the
            same screen. Each tab contains separate information related to the
            same topic. Use this component only when the tab content is not
            readable when displayed all at once.
          </p>
        </Intro>

        <SectionTitle>Tabs</SectionTitle>
        <p>
          The tab component consists of a container, a tab bar, text labels, and
          the tab content. In addition to the default state, the tab bar also
          has a hover state and a focus state. The selected and unselected
          states mark the active and inactive tabs, respectively.
        </p>

        <Showcase
          site={data.site}
          title=""
          text="Tabs require javascript to change the display on the c-tabs__content class and
          the c-tabs__tab--active class."
          code={code.tabs}
        >
          <div>
            <div class="c-tabs">
              <div
                class="c-tabs__tab c-tabs__tab--active"
                onClick={event => showTab(event, 'content1')}
                onKeyDown={event => showTab(event, 'content1')}
                role="button"
                tabIndex={0}
              >
                Tab Label 1
              </div>
              <div
                class="c-tabs__tab"
                onClick={event => showTab(event, 'content2')}
                onKeyDown={event => showTab(event, 'content2')}
                role="button"
                tabIndex={0}
              >
                Tab Label 2
              </div>
            </div>
            <div
              id="content1"
              class="c-tabs__content c-tabs__content--active l-padding-vertical--medium"
            >
              <p class="c-text-content">This is the content for Tab 1.</p>
            </div>
            <div
              id="content2"
              class="c-tabs__content l-padding-vertical--medium"
            >
              <p class="c-text-content">This is the content for Tab 2.</p>
            </div>
          </div>
        </Showcase>
        <SectionTitle>Accessibility</SectionTitle>
        <p>Content coming soon</p>

        <SectionTitle>Design Environment</SectionTitle>
        <p>Content coming soon</p>
      </Layout>
    </>
  )
}

export const code = {
  tabs: `<div>
  <div class="c-tabs">
    <div class="c-tabs__tab c-tabs__tab--active">Tab Label 1</div>
    <div class="c-tabs__tab">Tab Label 2</div>      
  </div>
  <div class="c-tabs__content c-tabs__content--active l-padding-vertical--medium">
    <p class="c-text-content">This is the content for Tab 1.</p>
  </div>
  <div class="c-tabs__content l-padding-vertical--medium">
    <p class="c-text-content">This is the content for Tab 2.</p>
  </div>    
</div>`,
}
